export const formatName = (input) => {
    if (!input || typeof input !== "string") {
        return {
            error: true,
            errorMessage: "Invalid input: name must be a non-empty string",
            data: null,
        };
    }
    // Remove any leading/trailing spaces and normalize internal whitespace
    const cleaned = input
        .replace(/,/g, " ") // treat commas as spaces
        .replace(/\s+/g, " ") // collapse multiple spaces
        .trim();
    if (cleaned.length === 0) {
        return {
            error: true,
            errorMessage: "Invalid input: name is empty after trimming",
            data: null,
        };
    }
    const [firstName = " ", ...rest] = cleaned.split(" ");
    // Capitalize first letter of each word
    const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
    const normalizedFirst = cap(firstName);
    const normalizedLast = rest.map(cap).join(" ") || " ";
    return {
        error: false,
        errorMessage: null,
        data: {
            firstName: normalizedFirst,
            lastName: normalizedLast,
        },
    };
};
//# sourceMappingURL=formatName.js.map